module.exports = __webpack_public_path__ + "8feefde0e7c9308f6a4102e3a86c2205.svg";